import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import api from '../api';

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  [api.baseKemedis.baseKemedisApi.reducerPath]: api.baseKemedis.baseKemedisApi.reducer,
});

export default rootReducer;
